define(['underscore',
    './aspects/Requiredness',
    './aspects/Validity',
    './aspects/AvailableValues'], (_, requiredness, validity, availableValues)=> {
    const INPUT_CTRL_TYPES = {
        'Choice': 'SELECT',
        'String': 'TEXT',
        'Boolean': 'RADIO'
    };


    function createQuestionSetViewModel(questionSets, modelValue, translator) {
        function createQuestionViewModel(question) {
            const questionVmNode = {
                get code() {
                    return question.code;
                },
                get label() {
                    return question.displayKey;
                },
                get answer() {
                    //set radio buttons default answer to false
                    if (question.questionType === 'Boolean' && modelValue.answers[question.code] === undefined) {
                        return false;
                    }
                    return modelValue.answers[question.code];
                },
                set answer(answerValue) {
                    modelValue.answers[question.code] = answerValue;
                },
                get type() {
                    return INPUT_CTRL_TYPES[question.questionType];
                },
                aspects: {}
            };

            const aspectProperties = requiredness(questionVmNode, question, modelValue.answers);
            _.extendOwn(aspectProperties, validity(questionVmNode, translator));
            _.extendOwn(aspectProperties, availableValues(question));

            Object.getOwnPropertyNames(aspectProperties).forEach((propName)=> {
                Object.defineProperty(questionVmNode.aspects, propName, aspectProperties[propName]);
            });

            return questionVmNode;
        }

        function getQuestionSet(qsName) {
            const questionSet = questionSets[qsName];
            if (!questionSet || !questionSet.orderedQuestions) {
                throw new Error(`There is no question set loaded with the name ${qsName}`);
            }
            return questionSet;
        }

        //note: uses ducktyping, checking if answers is a view model object by looking at aspects property
        //if view model already created then just return that object
        if (modelValue.aspects && modelValue.questions && _.isArray(modelValue.questions)) {
            return modelValue;
        }

        const qsViewModel = {
            value: modelValue
        };
        const questionSet = getQuestionSet(modelValue.code);

        const allQuestions = questionSet.orderedQuestions.sort((a, b)=> {
            return a.order - b.order;
        });

        const availableQuestions = _.filter(allQuestions, (question)=> {
            return modelValue.answers[question.code] !== undefined;
        });
        qsViewModel.questions = availableQuestions.map(createQuestionViewModel);

        return qsViewModel;
    }

    return {
        create: (questionSets, translator)=> {
            return {
                /**
                 * Creates a new question set view model object with aspects expected by form input controls.
                 *
                 * @param qsModelArrayOrObject {Object | Array}: QuestionSetAnswersDTO model object or array that is used to create the view model. If the object
                 * passed in is a view model object then it will just be returned as is
                 *
                 * @return {Array}: A new view model object or array of view model objects with a top level serializedForm aspect
                 */
                getQuestionSetViewModel: (qsModelArrayOrObject)=> {
                    if (!qsModelArrayOrObject && !(_.isObject(qsModelArrayOrObject) || _.isArray(qsModelArrayOrObject))) {
                        throw new Error('An model object is required for storing answers');
                    }

                    if (_.isArray(qsModelArrayOrObject)) {
                        return qsModelArrayOrObject.map((qsModel)=> {
                            return createQuestionSetViewModel(questionSets, qsModel, translator);
                        });
                    }

                    return [createQuestionSetViewModel(questionSets, qsModelArrayOrObject, translator)];
                }
            };
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/questionsets/QuestionSetFactory.js
 **/